import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoadingDialogComponent } from './loading-dialog.component';

@Injectable({ providedIn: 'root' })
export class LoadingDialogService {
  private dialogRef: MatDialogRef<LoadingDialogComponent> | null = null;
  private loadingCount = 0;

  constructor(private dialog: MatDialog) {}

  start(message?: string): void {
    this.loadingCount++;

    // Só abre no primeiro
    if (this.loadingCount === 1) {
      this.dialogRef = this.dialog.open(LoadingDialogComponent, {
        disableClose: true,
        data: message?.trim() ? message : 'Aguarde...',
      });
    }
  }

  stop(): void {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }

    // Só fecha quando TODAS terminaram
    if (this.loadingCount === 0 && this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
